__turbopack_context__.v({
  "backdrop": "HDefault-module__EeDlDG__backdrop",
  "backdropOpen": "HDefault-module__EeDlDG__backdropOpen",
  "bottomRow": "HDefault-module__EeDlDG__bottomRow",
  "brand": "HDefault-module__EeDlDG__brand",
  "brandLink": "HDefault-module__EeDlDG__brandLink",
  "controls": "HDefault-module__EeDlDG__controls",
  "hamburger": "HDefault-module__EeDlDG__hamburger",
  "hamburgerBar": "HDefault-module__EeDlDG__hamburgerBar",
  "hamburgerOpen": "HDefault-module__EeDlDG__hamburgerOpen",
  "inner": "HDefault-module__EeDlDG__inner",
  "logo": "HDefault-module__EeDlDG__logo",
  "root": "HDefault-module__EeDlDG__root",
  "rootHidden": "HDefault-module__EeDlDG__rootHidden",
  "topRow": "HDefault-module__EeDlDG__topRow",
  "windowsArea": "HDefault-module__EeDlDG__windowsArea",
  "windowsAreaColumn": "HDefault-module__EeDlDG__windowsAreaColumn",
  "windowsAreaOpen": "HDefault-module__EeDlDG__windowsAreaOpen",
});
